import { render } from "./navigation-bar.vue?vue&type=template&id=14192c24"
import script from "./navigation-bar.vue?vue&type=script&setup=true&lang=ts"
export * from "./navigation-bar.vue?vue&type=script&setup=true&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "14192c24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('14192c24', script)) {
    api.reload('14192c24', script)
  }
  
  module.hot.accept("./navigation-bar.vue?vue&type=template&id=14192c24", () => {
    api.rerender('14192c24', render)
  })

}

script.__file = "resources/scripts/components/navigation-bar.vue"

export default script